import React, { useEffect, useState } from "react";
import { Switch, Route } from "react-router-dom";
import { OrganizationWrapper } from "./style";
import Sidebar from "@/views/Layout/Sidebar";
import { MENU_ITEMS } from "@/views/Layout/Sidebar/type";
import OrganizationApplications from "@/views/Organization/Applications";
import OrganizationBilling from "@/views/Organization/Billing";
import OrganizationContact from "@/views/Organization/Contact";
import OrganizationContract from "@/views/Organization/Contract";
import OrganizationGeneral from "@/views/Organization/General";
import OrganizationMembers from "@/views/Organization/Members";
import { PATH_APP } from "@/routes/paths";
import ForwardToInboxIcon from "@mui/icons-material/ForwardToInbox";
import { SnackbarProvider } from "notistack";
import { makeStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(() => {
	return {
		contactUsInfo: {
			fontSize: `14px !important`,
			color: `black !important`,
			backgroundColor: `#FFC233 !important`,
			marginBottom: `30px !important`,
			display: "flex",
			justifyContent: "center",

			"& svg": {
				marginRight: "10px",
			},
		},
	};
});

export default function Organization() {
	const { i18n } = useTranslation();
	const classes = useStyles();
	const [menuItems, setMenuItems] = useState(
		MENU_ITEMS[i18n.language === "ko" ? 0 : 1],
	);
	useEffect(() => {
		switch (i18n.language) {
			case "ko":
				setMenuItems(MENU_ITEMS[0]);
				break;
			default:
				setMenuItems(MENU_ITEMS[1]);
		}
	}, [i18n.language]);

	return (
		<OrganizationWrapper>
			<Sidebar title="ORGANIZATION SETTINGS" menuItem={menuItems.organization} />
			<Switch>
				<Route
					exact={true}
					path={PATH_APP.organization.general}
					component={OrganizationGeneral}
				/>
				<Route
					exact={true}
					path={PATH_APP.organization.applications}
					component={OrganizationApplications}
				/>
				<Route
					exact={true}
					path={PATH_APP.organization.members}
					render={() => (
						<SnackbarProvider
							maxSnack={5}
							preventDuplicate
							autoHideDuration={1800}
							anchorOrigin={{
								vertical: "bottom",
								horizontal: "center",
							}}
							iconVariant={{
								info: <ForwardToInboxIcon />,
							}}
							classes={{
								variantInfo: classes.contactUsInfo,
							}}
						>
							<OrganizationMembers />
						</SnackbarProvider>
					)}
				/>
				<Route
					path={PATH_APP.organization.billing.root}
					component={OrganizationBilling}
				/>
				<Route
					exact={true}
					path={PATH_APP.organization.contact}
					render={() => (
						<SnackbarProvider
							maxSnack={5}
							preventDuplicate
							autoHideDuration={1800}
							anchorOrigin={{
								vertical: "bottom",
								horizontal: "center",
							}}
							iconVariant={{
								success: <ForwardToInboxIcon />,
							}}
							classes={{
								variantSuccess: classes.contactUsInfo,
							}}
						>
							<OrganizationContact />
						</SnackbarProvider>
					)}
				/>
				<Route
					path={PATH_APP.organization.contract}
					component={OrganizationContract}
				/>
			</Switch>
		</OrganizationWrapper>
	);
}
